import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import NavigationLink from "../navigation/navigationLink";

import "./subNavPoint.scss";

const SubNavPoint = ({
  className = undefined,
  color = "black",
  children,
  ...otherProps
}) => (
  <NavigationLink
    {...otherProps}
    className={classNames("sub-nav-point", `sub-nav-point--${color}`, className)}
  >
    {children}
  </NavigationLink>
);

SubNavPoint.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(["black", "white"]),
};

export default SubNavPoint;
